define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrDocTypeDomain = void 0;
    class SrCrDocTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrCrDocTypeDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrCrDocTypeDomain.Other] = 0;
                this.ValueIndex = {};
                this.ValueIndex["Other"] = 0;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrCrDocTypeDomain = SrCrDocTypeDomain;
    Object.defineProperty(SrCrDocTypeDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(SrCrDocTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
